module.exports = __webpack_public_path__ + "static/card-img-4-e90ad991ca6832cb80e65def4b91a918.jpg";